import { createElement, lazy } from 'react';
import { Outlet, type RouteObject } from 'react-router';

import { TaskLayout } from '@/layout';

const routes: RouteObject[] = [
  {
    path: 'labeling',
    Component: TaskLayout,
    children: [
      {
        path: ':projectId/:taskId',
        Component: lazy(() => import('@/page/task/TaskPage')),
      },
      {
        path: ':projectId/:taskId/:frameSeq',
        Component: lazy(() => import('@/page/task/TaskPage')),
      },
    ],
  },
  {
    path: 'cam',
    Component: () => createElement(Outlet),
    children: [
      {
        path: ':projectID/:taskID/:frameSeq',
        Component: lazy(() => import('@/page/task/CamPopupPage')),
      },
    ],
  },
];

export default routes;
